import { OauthAdapterService } from './oauth-adapter.service'

export function oAuthAdapterInitializerFactory(oAuthAdapterService: OauthAdapterService): () => Promise<void> {
  return async () => {
    await oAuthAdapterService.runInitialLoginSequence()
  }
}
